import { createContext } from 'preact';
import { useCallback, useState } from 'preact/hooks';

export const ApiCacheContext = createContext({});

export function ApiCacheProvider({ children }) {
  const [cache, setCache] = useState({});

  const getCached = useCallback((key) => cache[key], [cache]);

  const setCached = useCallback((key, data) => {
    setCache((prev) => ({ ...prev, [key]: data }));
  }, []);

  const clearCache = useCallback((key) => {
    if (key) {
      setCache((prev) => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
    } else {
      setCache({});
    }
  }, []);

  return (
    <ApiCacheContext.Provider value={{ getCached, setCached, clearCache }}>
      {children}
    </ApiCacheContext.Provider>
  );
}

export const DataContext = createContext({});
